module.exports = __webpack_public_path__ + "static/media/main idea.447c3019.mp3";